<h2 *ngIf="header" mat-dialog-title class="mb-3 text-center">{{ header }}</h2>
<div class="text-center mb-2" *ngIf="isQuestionShown">Are you sure?</div>
<mat-dialog-actions class="d-flex justify-content-between flex-nowrap m-0">
  <button mat-raised-button [mat-dialog-close]="false" class="mr-2">Cancel</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-raised-button [mat-dialog-close]="true" class="m-0">Yes</button>
</mat-dialog-actions>
